import { render, staticRenderFns } from "./Fuwu_detail.vue?vue&type=template&id=5babc826&"
import script from "./Fuwu_detail.vue?vue&type=script&lang=js&"
export * from "./Fuwu_detail.vue?vue&type=script&lang=js&"
import style0 from "./Fuwu_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports